import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];
const NAVY = "#0A234A";

const PILLARS = [
  { k: "Secure & gated", v: "Fenced, lit and monitored 24/7, so drivers finally feel safe stopping." },
  { k: "Hotel-grade rest", v: "Private sleep pods, hot showers, real food and green space to recover." },
  { k: "One app, one network", v: "Find, book and access every hub along the corridor from your phone." },
];

export const VisionSection = () => {
  return (
    <section
      data-testid="vision-section"
      className="relative overflow-hidden pt-20 lg:pt-28"
      style={{
        backgroundImage: "url(/assets/clouds-bg.jpg)",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="relative z-10 mx-auto w-full max-w-[1180px] px-6">
        {/* copy */}
        <div className="mx-auto max-w-3xl text-center">
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.5, ease: EASE }}
            className="mb-3 text-sm font-700 uppercase tracking-[0.18em] text-[#FF5722]"
          >
            Our solution
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, ease: EASE }}
            className="font-display text-3xl font-700 leading-[1.1] tracking-tight sm:text-5xl"
            style={{ color: NAVY }}
          >
            A network built for rest,
            <span className="block text-[#FF5722]">not just refuelling.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.05, ease: EASE }}
            className="mx-auto mt-5 max-w-2xl text-base font-400 leading-relaxed text-neutral-500"
          >
            FleetPods turns the roadside stop into a secure, hospitality-grade
            destination. Private sleep pods, real food, and calm green space,
            purpose-built for how drivers actually live and rest, and woven into
            the freight corridors they run every day.
          </motion.p>
        </div>

        {/* pillars as cards */}
        <div className="mx-auto mt-10 grid max-w-4xl gap-4 sm:grid-cols-3">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.k}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1, ease: EASE }}
              className="rounded-2xl border border-black/5 bg-white/80 p-6 text-left shadow-[0_20px_40px_-28px_rgba(10,35,74,0.4)] backdrop-blur-md transition-all duration-300 hover:-translate-y-0.5 hover:bg-white"
            >
              <div className="mb-3 h-[3px] w-8 rounded-full bg-[#FF5722]" />
              <h3 className="text-[15px] font-700" style={{ color: NAVY }}>{p.k}</h3>
              <p className="mt-1 text-sm font-400 leading-relaxed text-neutral-500">{p.v}</p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* full-bleed render — pulled up to tuck behind the cards */}
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="relative z-0 -mt-24 w-full lg:-mt-32"
      >
        <img
          src="/assets/vision-village.webp"
          alt="FleetPods pod village at dusk with driver rest pods and communal lodge"
          className="block w-full"
          draggable="false"
        />
      </motion.div>
    </section>
  );
};
